export const RETURN_RULES_SET_RETURN_RULES = 'RETURN_RULES_SET_RETURN_RULES'
export const RETURN_RULES_SET_RETURN_RULE = 'RETURN_RULES_SET_RETURN_RULE'
